import { ItemName } from '@features/List/ListItem.styles';
import styled from 'styled-components';

export const PackageItineraryWrapper = styled.div`
  padding: 0 10px;
`;

export const SpaItemName = styled(ItemName)`
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;
